import { FadeUp, Eyebrow } from '../motion';
import QuoteForm from '../QuoteForm';
import { useT } from '../../i18n/LangContext';

export default function FinalCta() {
  const t = useT();

  return (
    <section data-testid="final-cta-section" className="grain relative overflow-hidden bg-white py-24 text-ink md:py-32">
      <div className="container-site grid items-center gap-12 lg:grid-cols-2">
        <FadeUp>
          <Eyebrow dark>{t['fc.eyebrow']}</Eyebrow>
          <h2 className="mt-4 font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            {t['fc.h2a']} <span className="italic text-gold-dim">{t['fc.h2b']}</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-neutral-500">{t['fc.p']}</p>
          <ul className="mt-8 space-y-3">
            {[t['fc.b1'], t['fc.b2'], t['fc.b3']].map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm font-semibold">
                <span className="mt-1.5 inline-block h-2 w-2 shrink-0 bg-gold" /> {b}
              </li>
            ))}
          </ul>
        </FadeUp>
        <FadeUp delay={0.15}>
          <div className="rounded-2xl border border-black/10 bg-white p-7 shadow-2xl md:p-9">
            <QuoteForm variant="inline" source="final-cta" idPrefix="final-quote" />
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
